<div atlas-banner>
  <div atlas-banner-content>
    <p class="m-0 mat-body">
      Your Password was updated in your other device. Please sign in again.
    </p>
  </div>
</div>